// Paints a placeholder first, then mounts heavy content a frame (plus `delay` ms) later
// and fades it in. Keeps clicks responsive and lets charts arrive one after another.
// The placeholder stays blank for a moment and only starts shimmering if the content is
// slow, so quick switches don't flash a grey block.
import { useEffect, useState } from 'react';

const SHIMMER_AFTER_MS = 150;

const nextFrame = (cb) =>
  typeof window !== 'undefined' && window.requestAnimationFrame
    ? window.requestAnimationFrame(cb)
    : setTimeout(cb, 16);
const cancelFrame = (id) =>
  typeof window !== 'undefined' && window.cancelAnimationFrame ? window.cancelAnimationFrame(id) : clearTimeout(id);

export default function Deferred({ delay = 0, height = 320, className = '', children }) {
  const [ready, setReady] = useState(false);
  const [slow, setSlow] = useState(false);

  useEffect(() => {
    let f2;
    let t;
    // Two frames so the placeholder (and the tab change) actually paints first
    const f1 = nextFrame(() => {
      f2 = nextFrame(() => {
        t = setTimeout(() => setReady(true), delay);
      });
    });
    const s = setTimeout(() => setSlow(true), SHIMMER_AFTER_MS);
    return () => {
      cancelFrame(f1);
      cancelFrame(f2);
      clearTimeout(t);
      clearTimeout(s);
    };
  }, [delay]);

  if (!ready) {
    return (
      <div
        className={`${slow ? 'cx-skel rx-skel-block rx-skel-in' : 'rx-skel-block rx-skel-blank'} ${className}`}
        style={{ height }}
        aria-busy="true"
      />
    );
  }
  return <div className={`rx-deferred rx-fade-in ${className}`}>{children}</div>;
}
